import React from 'react'
import { Heading } from '@chakra-ui/react'
import { ImHtmlFive2 } from "react-icons/im"
import { TbBrandJavascript } from "react-icons/tb"
import { IoLogoCss3 } from "react-icons/io"
import { SiTypescript, SiNextdotjs, SiExpress, SiSwagger } from "react-icons/si"
import { DiReact, DiNodejs, DiMongodb } from "react-icons/di"
import styles from "../../styles/Skill.module.css"
import Calender from '../Git Calender/Calender'
import Streek from '../Git Calender/Streek'

const Skill = () => {
  return (
    <div id='skills' className={styles.skill}>
      <Heading textDecoration="underline" marginTop="50px" fontSize="45px" fontWeight="400" textAlign={'center'}>My Skills</Heading>

      <div className={styles.childskill}>
        <div className='skills-card'>
          <i>
            <ImHtmlFive2 className='skills-card-img' size={'100%'} />
          </i>
          <h3 className='skills-card-name'>HTML</h3>
        </div>
        <div className='skills-card'>
          <i>
            <IoLogoCss3 className='skills-card-img' size={'100%'} />
          </i>
          <h3 className='skills-card-name'>CSS</h3>
        </div>
        <div className='skills-card'>
          <i>
            <TbBrandJavascript className='skills-card-img' size={'100%'}/>
          </i>
          <h3 className='skills-card-name'>JavaScript</h3>
        </div>
        <div className='skills-card'>
          <i>
            <DiReact className='skills-card-img' size={'100%'}/>
          </i>
          <h3 className='skills-card-name'>React</h3>
        </div>
        <div className='skills-card'>
          <i>
            <DiNodejs className='skills-card-img' size={'100%'}/>
          </i>
          <h3 className='skills-card-name'>Node JS</h3>
        </div>
        <div className='skills-card'>
          <i>
            <SiTypescript className='skills-card-img' size={'100%'}/>
          </i>
          <h3 className='skills-card-name'>TypeScript</h3>
        </div>
        <div className='skills-card'>
          <i>
            <SiNextdotjs className='skills-card-img' size={'100%'}/>
          </i>
          <h3 className='skills-card-name'> Next JS</h3>
        </div>
        <div className='skills-card'>
          <i>
            <SiExpress className='skills-card-img' size={'100%'}/>
          </i>
          <h3 className='skills-card-name'>Express JS</h3>
        </div>
        <div className='skills-card'>
          <i>
            <DiMongodb className='skills-card-img' size={'100%'} />
          </i>
          <h3 className='skills-card-name'>MongoDB</h3>
        </div>
        <div className='skills-card'>
          <i>
            <SiSwagger className='skills-card-img' size={'100%'}/>
          </i>
          <h3 className='skills-card-name'>Swagger</h3>
        </div>
      </div>
      <Calender/>
      <Streek/>
    </div>
  )
}

export default Skill